module.exports = __webpack_public_path__ + "static/frog-6700261eaa9f752b0f05154ca9b4db9a.png";